import * as React from "react";
import type { SVGProps } from "react";
const SvgNoneMobileView = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={390} height={192} fill="none" {...props}>
        <path fill="#F2F2F2" d="M0 0h390v192H0z" />
        <path
            fill="#DCDCDC"
            d="M335.102 28.527c0-15.587-12.636-28.222-28.222-28.222h-50.025c-14.405 0-26.083 11.677-26.083 26.082s-11.677 26.082-26.082 26.082H83.222C67.636 52.47 55 65.105 55 80.691v45.618c0 15.586 12.636 28.221 28.222 28.221h199.715c10.021 0 18.144-8.123 18.144-18.144v-1.134c0-9.394 7.616-17.01 17.01-17.01s17.011-7.616 17.011-17.01z"
        />
        <path fill="#767676" d="M218.612 134.669V67.093a3.31 3.31 0 0 1 3.31-3.31h96.171a3.31 3.31 0 0 1 3.309 3.31v67.576z" />
        <path
            fill="#BAE5FF"
            d="M314.185 67.093h-88.526a3.31 3.31 0 0 0-3.309 3.309v56.259a3.31 3.31 0 0 0 3.309 3.31h88.526a3.31 3.31 0 0 0 3.309-3.31v-56.26a3.31 3.31 0 0 0-3.309-3.308"
        />
        <circle cx={243.034} cy={94.395} r={9.928} fill="#1796EB" />
        <path
            fill="#fff"
            fillRule="evenodd"
            d="M248.495 90.742c.385.419.359 1.07-.06 1.457l-7.604 7.007-3.516-3.85a1.031 1.031 0 0 1 1.523-1.39l2.119 2.32 6.081-5.603a1.03 1.03 0 0 1 1.457.059"
            clipRule="evenodd"
        />
        <path
            fill="#AAA"
            d="M338.45 133.588H201.561c-.856 0-1.55.404-1.55.902v2.852c0 .498.694.902 1.55.902H338.45c.857 0 1.551-.404 1.551-.902v-2.852c0-.498-.694-.902-1.551-.902"
        />
        <path
            fill="#009"
            d="M315.838 67.092h-91.836c-.914 0-1.654.741-1.654 1.655v5.791h95.144v-5.791c0-.914-.741-1.655-1.654-1.655"
        />
        <path
            fill="#fff"
            d="M282.107 86.502h27.75a1.017 1.017 0 0 0 0-2.036h-27.75a1.017 1.017 0 0 0 0 2.036M267.215 111.322h27.749a1.018 1.018 0 0 0 0-2.035h-27.749a1.017 1.017 0 1 0 0 2.035M267.215 116.286h27.749a1.018 1.018 0 0 0 0-2.035h-27.749a1.017 1.017 0 1 0 0 2.035M282.107 91.466h27.75a1.017 1.017 0 0 0 0-2.035h-27.75a1.017 1.017 0 0 0 0 2.035M292.035 96.43h17.821a1.018 1.018 0 1 0 0-2.036h-17.821a1.017 1.017 0 0 0 0 2.036M267.215 121.25h17.821a1.018 1.018 0 1 0 0-2.035h-17.821a1.017 1.017 0 1 0 0 2.035M233.3 69.574h.179c.53 0 .96.43.96.96v.179c0 .53-.43.96-.96.96h-.179a.96.96 0 0 1-.959-.96v-.18c0-.53.429-.959.959-.959M225.789 69.574h.18c.53 0 .959.43.959.96v.179c0 .53-.429.96-.959.96h-.18a.96.96 0 0 1-.959-.96v-.18c0-.53.429-.959.959-.959M229.545 69.574h.179c.531 0 .96.43.96.96v.179c0 .53-.429.96-.96.96h-.179a.96.96 0 0 1-.959-.96v-.18c0-.53.429-.959.959-.959M302.562 109.432l1.583 4.233 2.647-2.65z"
        />
        <path fill="#fff" d="m305.112 111.39-.591.591 1.311 1.312.592-.591z" />
        <path
            fill="#FF9E82"
            d="m133.3 71.624 32.388-7.085-46.286 58.504-5.482-31.457zM146.356 142.374s12.336.017 15.122.017c4.351 0 5.151-.367 5.54-.52a7.671 7.671 0 0 0 4.243-4.053 7.7 7.7 0 0 0 .142-5.874l-.011.002.007-.011-6.987-.006.002-.013h-.011l-28.505-.23-4.41 10.688z"
        />
        <path
            fill="#FF9E82"
            d="M143.246 107.33s12.335.017 15.121.017c4.352 0 5.152-.367 5.541-.519a7.66 7.66 0 0 0 4.243-4.053 7.7 7.7 0 0 0 .142-5.875l-.011.002.007-.01-6.987-.006.001-.013a.01.01 0 0 1-.01 0l-28.505-.23-4.41 10.687zM143.246 124.866s12.335.017 15.121.017c4.352 0 5.152-.367 5.541-.519a7.7 7.7 0 0 0 2.523-1.604 7.7 7.7 0 0 0 1.72-2.449 7.7 7.7 0 0 0 .142-5.875l-.011.002.007-.011-6.987-.005.001-.014h-.01l-28.505-.23-4.41 10.688z"
        />
        <rect width={60.403} height={122.093} x={127.047} y={10.023} fill="#fff" stroke="#DCDCDC" strokeWidth={3.344} rx={9.03} />
        <rect width={62.873} height={125.077} x={123} y={8.351} fill="#fff" rx={10.702} />
        <rect width={32.601} height={8.15} x={137.707} y={110.14} fill="#DCDCDC" rx={4.075} />
        <rect width={32.601} height={2.038} x={138.036} y={26.313} fill="#DCDCDC" rx={1.019} />
        <rect width={24.451} height={2.038} x={142.717} y={30.987} fill="#DCDCDC" rx={1.019} />
        <rect width={4.075} height={2.038} x={131.34} y={15.038} fill="#DCDCDC" rx={1.019} />
        <rect width={4.075} height={2.038} x={173.481} y={15.038} fill="#DCDCDC" rx={1.019} />
        <rect width={4.075} height={2.038} x={168.801} y={15.038} fill="#DCDCDC" rx={1.019} />
        <path
            fill="#FFC2B0"
            d="m123.272 70.1-27.99 34.619s-6.869 7.973-6.868 24.281v42.949L81.7 191.666l47.786.029 2.618-71.19s-20.15.978-11.676-16.33l2.843-6.014z"
        />
        <path
            fill="#FFC2B0"
            d="M122.189 167.689s26.694 2.133 28.496-18.309l3.872-58.039c.944-10.7-9.726-11.647-9.726-11.647l-13.125 41.04-5.335-.473z"
        />
        <path
            fill="#FE8F11"
            d="M151.391 46.862c1.434-2.483 5.017-2.483 6.451 0l9.513 16.477c1.433 2.483-.359 5.586-3.226 5.586h-19.025c-2.867 0-4.659-3.103-3.225-5.586z"
        />
        <path
            fill="#fff"
            fillRule="evenodd"
            d="M155.84 52.26a1.156 1.156 0 0 0-2.313 0v9.251a1.157 1.157 0 0 0 2.313 0zm-1.157 14.454a1.734 1.734 0 1 0 0-3.468 1.734 1.734 0 0 0 0 3.468"
            clipRule="evenodd"
        />
    </svg>
);
export default SvgNoneMobileView;
